import { Inject, Pipe, PipeTransform } from "@angular/core";
import { intersection } from "lodash";
import { AUDIO_CHANNEL_PRESETS } from "../components/common-form/special-fields/audio-configurations/templates";

@Pipe({ name: "audioConfigsMostCommonLanguage", pure: true })
export class AudioConfigMostCommonLanguagePipe implements PipeTransform {
    public transform(audioConfigs: any[]): string | undefined {
        if (!!audioConfigs && audioConfigs.length > 0) {
            const langs = {};
            let mostFrequent;
            audioConfigs.forEach((config) => {
                if (!langs[config.language]) {
                    langs[config.language] = 0;
                }
                langs[config.language]++;
                if (mostFrequent === undefined) { mostFrequent = config.language; }
                if (langs[config.language] > langs[mostFrequent]) {
                    mostFrequent = config.language;
                }
            });
            return mostFrequent;
        } else {
            return undefined;
        }
    }
}

@Pipe({ name: "audioConfigsShorthand", pure: true })
export class AudioConfigShorthandPipe implements PipeTransform {

    constructor( @Inject(AUDIO_CHANNEL_PRESETS) public templates) { }

    public transform(audioConfigs: any[]): string {
        const abbrValues = new Set();
        if (!!audioConfigs && audioConfigs.length > 0) {
            this.templates
                .filter((template) => this.templateFoundInConfig(template, audioConfigs))
                .filter((template) => !this.isSplitTrack(template))
                .forEach((template) => abbrValues.add(template.abbreviation));
            return Array.from(abbrValues).join(" / ");
        } else {
            return "";
        }
    }

    public templateFoundInConfig(template, configs): boolean {
        const selectedPositions = configs.map((config) => config.position);
        return intersection(template.positions, selectedPositions).length > 0;
    }

    public isSplitTrack(template): boolean {
        return template.name.includes("Split Track");
    }
}

@Pipe({ name: "separateFilesShorthand", pure: true })
export class SeparateFilesShorthandPipe implements PipeTransform {

    constructor( @Inject(AUDIO_CHANNEL_PRESETS) public templates) { }

    public transform(separateFiles: any[]): string {
        return separateFiles.map((sf) => `${sf.language} ${sf.track}`).join(", ");
    }
}
